/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../../components/common/new/InputField/InputField";
import useQueryParams from "../../../hooks/useQueryParams";
import {
  SET_CITIES,
  SET_DIVISIONS,
  SET_STATES,
  SET_SUB_DIVISIONS,
  SET_SPECIAL_GROUP,
} from "../../../redux/actionTypes/meta";
import IntroductionFormApi from "../../../services/api/introductionForm";
import SpecialGroup from "../../../services/api/SpecialGroup";
import { getOptions } from "../../../utils";
import { isEmptyObj } from "../../../utils/helper";
import Styles from "../FriendsReports/FriendSearch.styles";

function PersonalDetailsSearch() {
  const [stateVal, setStateVal] = useState("");
  const [divisionVal, setDivisionVal] = useState("");
  const [subDivisionVal, setSubDivisionVal] = useState("");
  const [cityVal, setCityVal] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [specialGroups, setSpecialGroups] = useState([]);
  const [specialGroupVal, setSpecialGroupVal] = useState("");
  const dispatch = useDispatch();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();

  const setMetaDataInRedux = (type, payload) => {
    dispatch({
      type,
      payload,
    });
  };

  const getDivisions = async () => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);
    setMetaDataInRedux(SET_DIVISIONS, response.data);
  };

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
    setMetaDataInRedux(SET_STATES, response.data);
  };

  const getSpecialGroup = async (divisionId) => {
    const response = await SpecialGroup.getDivisionSpecialGroup({
      divisionId,
    });
    setSpecialGroups(response.data);
    setMetaDataInRedux(SET_SPECIAL_GROUP, response.data);
  };

  useEffect(() => {
    getDivisions();
    getStates();
  }, []);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      setStateVal(query?.stateId || "");
      setCityVal(query?.cityId || "");
      setDivisionVal(query?.divisionId || "");
      setSubDivisionVal(query?.subDivisionId || "");
      setSpecialGroupVal(query?.specialGroupId || "");
    } else {
      setStateVal("");
      setCityVal("");
      setDivisionVal("");
      setSubDivisionVal("");
      setSpecialGroupVal("");
    }
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    if (states.length && stateVal) {
      const newCities =
        states.find((state) => state.stateId === Number(stateVal))?.cities ??
        [];
      setCities(newCities);
      setMetaDataInRedux(SET_CITIES, newCities);
    }
  }, [states, stateVal]);

  useEffect(() => {
    if (divisions.length && divisionVal) {
      const newSubDivisions =
        divisions.find(
          (division) => division.divisionId === Number(divisionVal)
        )?.subDivisions ?? [];
      setSubDivisions(newSubDivisions);
      setMetaDataInRedux(SET_SUB_DIVISIONS, newSubDivisions);
      getSpecialGroup(divisionVal);
    }
  }, [divisions, divisionVal]);

  return (
    <Box
      sx={{
        px: 0,
        pt: 0,
        "& .MuiInputLabel-root": {
          fontSize: "12px !important",
          fontWeight: "600 !important",
          lineHeight: "13px !important",
          paddingBottom: "2px !important",
        },
        "& .MuiOutlinedInput-input": {
          height: "12px",
        },
      }}
    >
      <Box sx={{ pl: { xs: 0, sm: 2, md: 0 }, width: "100%" }}>
        <Grid
          container
          spacing={2}
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "repeat(4, 1fr)",
            },
            rowGap: 0,
            columnGap: 1,
          }}
        >
          {/* Group 1 */}
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              paddingRight: "8px",
              paddingBottom: "8px",
              boxShadow: "1px 0 2px 0 #e7e2e2",
            }}
          >
            <InputField
              label="Member Id"
              name="id"
              style={Styles.textfieldStyle}
            />
            <InputField
              label="Member Name"
              name="fullName"
              style={Styles.textfieldStyle}
            />
          </Grid>

          {/* Group 2 */}
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              paddingRight: "8px",
              paddingBottom: "8px",
              boxShadow: "1px 0 2px 0 #e7e2e2",
            }}
          >
            <InputField
              label="Phone Number"
              name="mobileNumber"
              type="text"
              style={Styles.textfieldStyle}
              inputProps={{ maxLength: 10 }}
            />
            <InputField
              label="Email Id"
              name="emailId"
              style={Styles.textfieldStyle}
              type="email"
            />
          </Grid>

          {/* Group 3 */}
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              paddingRight: "8px",
              paddingBottom: "8px",
              boxShadow: "1px 0 2px 0 #e7e2e2",
            }}
          >
            <InputField
              label="Address"
              name="address"
              style={Styles.textfieldStyle}
            />
            <InputField
              label="Pincode"
              type="text"
              name="pincode"
              style={Styles.textfieldStyle}
              inputProps={{ maxLength: 6 }}
            />
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.stateName}
              label="State"
              name="stateId"
              options={getOptions(states, "stateId")}
              value={stateVal}
              style={Styles.dropdownfieldStyle}
              inputProps={{ required: false }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setStateVal("");
                  setCities([]);
                } else {
                  setStateVal(selectedValue.value);
                  setCities(selectedValue.cities);
                  setMetaDataInRedux(SET_CITIES, selectedValue.cities);
                }
              }}
              useHiddenInput
            />
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.cityName}
              label="City"
              name="cityId"
              options={getOptions(cities, "cityId")}
              value={cityVal}
              style={Styles.dropdownfieldStyle}
              disabled={!stateVal}
              inputProps={{ required: false }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setCityVal("");
                } else {
                  setCityVal(selectedValue.value);
                }
              }}
              useHiddenInput
            />
          </Grid>

          {/* Group 4 */}
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              paddingRight: "8px",
              paddingBottom: "8px",
              boxShadow: "1px 0 2px 0 #e7e2e2",
            }}
          >
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.shortName}
              label="Division"
              name="divisionId"
              options={getOptions(divisions, "divisionId")}
              value={divisionVal}
              style={Styles.dropdownfieldStyle}
              inputProps={{ required: false }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setDivisionVal("");
                  setSubDivisions([]);
                } else {
                  setDivisionVal(selectedValue.value);
                  setSubDivisions(selectedValue.subDivisions);
                  setMetaDataInRedux(
                    SET_SUB_DIVISIONS,
                    selectedValue.subDivisions
                  );
                }
              }}
              useHiddenInput
            />
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              label="Sub Division"
              name="subDivisionId"
              options={getOptions(subDivisions, "divisionId")}
              value={subDivisionVal}
              style={Styles.dropdownfieldStyle}
              disabled={!divisionVal}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setSubDivisionVal("");
                } else {
                  setSubDivisionVal(selectedValue.value);
                }
              }}
              useHiddenInput
            />
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              options={getOptions(specialGroups, "specialGroupId")}
              label="Special Group"
              name="specialGroupId"
              disabled={!divisionVal}
              value={specialGroupVal}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setSpecialGroupVal("");
                } else {
                  setSpecialGroupVal(selectedValue.value);
                }
              }}
              inputProps={{ required: false }}
              useHiddenInput
              style={Styles.dropdownfieldStyle}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default PersonalDetailsSearch;
